import { InjectionToken } from '@angular/core';

import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';

import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'partecipata-servizio';

export const ENTITY_PLURAL = 'Servizi Affidati';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Aff. Diretto',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swAffidoDiretto',
  },
  {
    elementLabel: 'Missione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'missione.descrizione',
  },
  {
    elementLabel: 'Attivo',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swServizioAttivo',
  },
  {
    elementLabel: 'Pubblico',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swServizioPubblico',
  },
  {
    elementLabel: 'Servizio Pubblico',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'servizioPubblico.descrizione',
  },
  {
    elementLabel: 'Inizio Servizio',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataInizio',
  },
  {
    elementLabel: 'Fine Servizio',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataFine',
  },
  {
    elementLabel: 'Estremi Affido',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'estremiAffido',
  },
  {
    elementLabel: 'Attività',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'attivita-partecipata.descrizione',
  },
  // {
  //   elementLabel: 'Disabilitato',
  //   filterType: FilterType.boolean,
  //   fieldType: FieldType.boolean,
  //   field: 'disabilita',
  // },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
